import { render, staticRenderFns } from "./Card6.vue?vue&type=template&id=6597063a&scoped=true"
import script from "./Card6.vue?vue&type=script&lang=js"
export * from "./Card6.vue?vue&type=script&lang=js"
import style0 from "./Card6.vue?vue&type=style&index=0&id=6597063a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6597063a",
  null
  
)

export default component.exports